import { min, max } from 'd3-array';
import { bandAxis, linearAxis } from '../../../factory/axes';
import gva from './data/gva.json';
// import data from './data/data.json';

export default function (props, d) {
  const { initialWidth, initialHeight, isMobile } = props;

  const data = [];
  d.forEach((obj) => {
    if (obj.year > '2013') {
      data.push({
        label: obj.year,
        amt: obj.value.length,
      });
    }
  });


  const margins = {
    top: 5,
    right: isMobile ? 10 : 30,
    bottom: 20,
    left: 35,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  const padding = 0.15;

  const maxValue = max(data, d => d.amt);
  const minValue = min(data, d => d.amt);

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width],
    domain: data.map(d => d.label),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [height, 0],
    domain: [Math.min(0, minValue), maxValue + 100],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  return {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  };
}
